import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'

import { translate } from 'parking-react-common'

import { ui, routing, forms } from '../redux'

import form from '../components/Form'
import { Row, Column } from '../components/Grid'
import Input from '../components/Input'
import Button from '../components/Button'

const EmailPasswordChangeForm = ({ isSubmitting, isPristine, t }) => (
    <div>
        <Field
            name="old_password"
            placeholder={ t('Old Password') }
            component={ Input }
            type="password"
        />
        <Field
            name="new_password1"
            placeholder={ t('New Password') }
            component={ Input }
            type="password"
        />
        <Field
            name="new_password2"
            placeholder={ t('Confirm Password') }
            component={ Input }
            type="password"
        />
        <Row>
            <Column span={ 6 }>
                <Button
                    type="submit"
                    label={ t('Save') }
                    size={ ui.SIZE.large }
                    intent={ ui.INTENT.primary }
                    isBlock
                    disabled={ isSubmitting || isPristine }
                />
            </Column>
            <Column span={ 6 }>
                <Button
                    label={ t('Cancel') }
                    size={ ui.SIZE.large }
                    link={ routing.routeFor('dashboard') }
                    isBlock
                />
            </Column>
        </Row>
    </div>
)

EmailPasswordChangeForm.propTypes = {
    isSubmitting : PropTypes.bool,
    isPristine   : PropTypes.bool
}

export default translate()(form({ id: forms.emailPasswordChange.id })(EmailPasswordChangeForm))
